import { getControls } from "utils";
import { useTransformContext } from "./use-transform-context";
export var useControls = function () {
    var libraryContext = useTransformContext();
    return getControls(libraryContext);
};
